<template>
  <div class="home">
    <div class="body_html">
      <h1>代理商管理</h1>
      <div class="wei_body">
        <div class="tianjia">
          <main>代理商等级列表</main>
          <el-button
            @click="onSubmit = true"
            style="font-size: 16px; margin-top: 4.0rem; color: #2890dd"
            >添加</el-button
          >
          <el-table
            :data="tableData.data"
            
            style="width: 100%; text-aligh: center; margin-top: 4.0rem"
          >
            <el-table-column
              prop="levelName"
              label="代理商等级"
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="discount_price"
              label="折扣价格"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="addtime"
              label="日期"
              style="width: 40%"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 10%">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                ></el-button>
                <el-button
                  type="text"
                  @click="dele(scope.row.id)"
                  size="small"
                  style="color: rgb(244, 96, 85)"
                >
                  <img
                    src="../../../assets/omitted.png"
                    alt
                    style="position: relative; top: 1.0rem; right: 4px"
                  />删除
                </el-button>
                <el-button
                  type="text"
                  @click="
                    (dialogVisible = true),
                      modify(
                        scope.row.id,
                        scope.row.levelName,
                        scope.row.discount_price
                      )
                  "
                  size="small"
                  style="color: rgb(40, 144, 221)"
                >
                  <img
                    src="../../../assets/modification.png"
                    alt
                    style="position: relative; top: 1.0rem; right: 4px"
                  />编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-sizes="[10,20,50,100]"
            :page-size="20"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="prev, pager, next, jumper"
            style="margin-top: 3.0rem"
            :total="tableData.count"
          ></el-pagination>
        </div>
        <el-dialog
          title="修改代理商等级"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="等级编辑">
              <el-input clearable v-model="dengj">{{ dengj }}</el-input>
            </el-form-item>
            <el-form-item label="折扣">
              <el-input clearable v-model="mani" style="width: 30%">{{ mani }}</el-input>
              <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;折</span
              >
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="添加代理商等级" center :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="代理商等级">
              <el-input clearable v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="折扣" style="width: 30%">
              <el-input
                clearable
                v-model="form.mani"
                style="display: inline-block"
              ></el-input>
              <span class="onmf" style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;折</span
              >
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        mani: "",
      },
      onSubmit: false,
      modifys: "", //修改点击来接收的id,
      dengj: "",
      mani: "", //价格
      tooken: "",
      title: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.haha();
  },
  methods: {
    // tooken验证
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/level/getLevelList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            //page: val,
            page:this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data;
        })
        .catch(function (err) {});
    },
    haha() {
      this.axios
        .post(
          "/api/level/getLevelList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data;
        })
        .catch(function (err) {});
    },
    //  通过点击事件触发监听事件rowbundleRenderer
    modify(e, l, el) {
      this.modifys = e;
      this.mani = el;
      this.dengj = l;
    },
    vak() {
      // 修改代理商等级
      var aaa = this.dengj;
      if (aaa !== "") {
        this.axios
          .post(
            "/api/level/editLevel",
            qs.stringify({
              levelName: this.dengj,
              id: this.modifys,
              discount_price: this.mani,
              totaltoken: this.tooken.totaltoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/Tagent");
            }
            if (res.data.code == 1) {
              this.dialogVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
            this.haha();
          })
          .catch(function (err) {});
      } else {
        this.$message.error("修改代理商不能为空");
        return;
      }
    },

    handleClick(row) {},
    // 删除代理等级管理
    dele(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/api/level/delLevel",
              qs.stringify({
                id: e,
                totaltoken: this.tooken.totaltoken,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/Tagent");
              }
              this.haha();
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message.error("取消删除");
        });
    },
    numoo() {
      if (this.form.name !== "") {
        this.axios
          .post(
            "/api/level/addlevel",
            qs.stringify({
              levelName: this.form.name,
              discount_price: this.form.mani,
              totaltoken: this.tooken.totaltoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/Tagent");
            }
            if (res.data.code == 1) {
              this.onSubmit = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.onSubmit = true;
              this.$message.error(res.data.msg);
            }
            this.haha();
          })
          .catch(function (err) {});
      } else {
        this.$message.error("添加代理商等级不能为空");
        return;
      }
    },
  },
};
</script>
<style scoped>
.wei_body {
  margin-top: 42px;
  width: 167.1rem;
  height: 942px;
  background-color: #ffffff;
  box-shadow: .0rem .1rem 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.onmf {
  position: relative;
  left: 9.0rem;
  bottom: 38px;
}
</style>

